import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const PageFailedLoading = () => {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="flex flex-col items-center">
                <TypographyH3>{UIStrings.OopsSomethingWentWrong}</TypographyH3>
                <TypographyP>{UIStrings.PleaseRefresh}</TypographyP>
            </div>
        </div>
    );
};

export default PageFailedLoading;
